(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtech-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ba-range]').forEach(function (range) {
      var frame = range.closest('.mtech-ba__frame');
      if (!frame) return;
      var afterWrap = frame.querySelector('[data-ba-after]');
      var handle = frame.querySelector('[data-ba-handle]');

      function update() {
        var v = range.value;
        if (afterWrap) afterWrap.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
        if (handle) handle.style.left = v + '%';
      }

      range.addEventListener('input', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtech-header"]) return;
  try {
    
  (function(){
    var navToggle = document.getElementById('mtechNavToggle');
    var mobileMenu = document.getElementById('mtechMobileMenu');
    if(navToggle && mobileMenu){
      navToggle.addEventListener('click', function(){
        var open = mobileMenu.classList.toggle('mtech-open');
        navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  })();

  (function(){
    var targets = document.querySelectorAll('[data-mtech-animate]');
    if(!targets.length) return;

    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)){
      targets.forEach(function(el){ el.classList.add('mtech-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var delay = entry.target.getAttribute('data-mtech-delay');
          if(delay){ entry.target.style.transitionDelay = delay + 'ms'; }
          entry.target.classList.add('mtech-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function(el){ observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtech-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var heroes = document.querySelectorAll('.mtech-cinehero');
    if (!heroes.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    heroes.forEach(function (hero) {
      requestAnimationFrame(function () {
        hero.classList.add('mtech-in');
      });

      if (reduceMotion || !hero.hasAttribute('data-mtech-hero-scroll')) return;

      var media = hero.querySelector('[data-mtech-hero-media] img, [data-mtech-hero-media] video');
      var content = hero.querySelector('[data-mtech-hero-content]');
      var ticking = false;

      function update() {
        ticking = false;
        var rect = hero.getBoundingClientRect();
        var heroHeight = rect.height || 1;
        var progress = Math.min(Math.max(-rect.top / heroHeight, 0), 1);

        if (media) {
          media.style.transform = 'scale(' + (1.22 + progress * 0.08) + ')';
        }
        if (content) {
          content.style.transform = 'translateY(' + (progress * -40) + 'px)';
          content.style.opacity = String(1 - progress * 0.7);
        }
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }, { passive: true });

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtech-sticky-buybar"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var bar = document.getElementById('mtechStickyBuybar');
    var btn = document.getElementById('mtechStickyBuybarBtn');
    if(!bar || !btn) return;

    var targetId = bar.getAttribute('data-target-section');
    var target = targetId ? document.getElementById('shopify-section-' + targetId) : null;

    if(!target){
      bar.style.display = 'none';
      return;
    }

    var showAfterPx = 480;
    var ticking = false;

    function update(){
      ticking = false;
      var scrollY = window.scrollY || document.documentElement.scrollTop;
      var targetTop = target.getBoundingClientRect().top + scrollY;
      var hideFrom = targetTop - 80;
      if(scrollY > showAfterPx && scrollY < hideFrom){
        bar.classList.add('mtech-visible');
      } else {
        bar.classList.remove('mtech-visible');
      }
    }

    function onScroll(){
      if(!ticking){
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    btn.addEventListener('click', function(){
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtech-vehicle-bar"]) return;
  try {
    
  (function(){
    var goBtn = document.getElementById('mtechVehicleGo');
    if(!goBtn) return;
    goBtn.addEventListener('click', function(){
      // No fitment app installed yet: build a plain-text search query from
      // the selected values and hand it to Shopify's native search. Once a
      // YMM/fitment app is installed, replace this with that app's filtered
      // collection URL (most build one like /collections/all?filter...).
      var parts = ['mtechYear', 'mtechSeries', 'mtechChassis', 'mtechLine'].map(function(id){
        var el = document.getElementById(id);
        return el && el.value && el.value !== 'All Products' ? el.value : '';
      }).filter(Boolean);
      var query = parts.join(' ');
      window.location.href = goBtn.dataset.searchUrl + '?q=' + encodeURIComponent(query);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
